/** /styles — Trois directions artistiques côte à côte, à choisir. Page temporaire. */
import React, { useState } from "react";

const T = {
  nuit: {
    nom: "A · Salon de nuit", tag: "Sombre, contrasté, luxe cosmétique",
    bg: "#101013", surf: "#191920", txt: "#F4EFE9", soft: "#A29B92",
    acc: "#D9B98C", acc2: "#E8836B", rule: "#2A2A33", r: 10,
    titre: "'Bodoni Moda', serif", ui: "'Manrope', sans-serif",
    pour: "Effet « spa haut de gamme ». Superbe en vitrine.",
    contre: "Sombre 8 h/jour, ça fatigue certains.",
  },
  choc: {
    nom: "B · Typo choc", tag: "Clair, radical, très marque",
    bg: "#FFFFFF", surf: "#F4F4F2", txt: "#0A0A0A", soft: "#5C5C58",
    acc: "#04624A", acc2: "#F5C13D", rule: "#0A0A0A", r: 2,
    titre: "'Archivo', sans-serif", ui: "'Archivo', sans-serif",
    pour: "Reconnaissable à 10 mètres, très affirmé.",
    contre: "Plus « jeune/punchy » que feutré.",
  },
  pigment: {
    nom: "C · Pigment", tag: "Chaud, coloré, sensuel",
    bg: "#FBF7F4", surf: "#FFFFFF", txt: "#2B1420", soft: "#7A6470",
    acc: "#E2542C", acc2: "#4A1D3F", rule: "#EADFD8", r: 14,
    titre: "'Fraunces', serif", ui: "'Manrope', sans-serif",
    pour: "Chaleur et caractère, féminin sans être genré.",
    contre: "Moins « premium froid » que le A.",
  },
};

function Maquette({ t, grand }) {
  const S = { fontFamily: t.ui, color: t.txt };
  return (
    <div style={{ background: t.bg, padding: grand ? 28 : 18, ...S }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <span style={{ fontFamily: t.titre, fontSize: grand ? 24 : 19, letterSpacing: "-.01em" }}>Servae</span>
        <span style={{ background: t.acc, color: t.bg, padding: "8px 14px", borderRadius: t.r, fontSize: 13, fontWeight: 700 }}>
          + Rendez-vous
        </span>
      </div>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".14em", color: t.acc, textTransform: "uppercase" }}>
        Prochain client
      </div>
      <div style={{ background: t.surf, border: `1px solid ${t.rule}`, borderRadius: t.r, padding: grand ? 22 : 16, marginTop: 10 }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
          <span style={{ fontFamily: t.titre, fontSize: grand ? 46 : 34, lineHeight: 1 }}>10h45</span>
          <span style={{ fontSize: grand ? 19 : 16, fontWeight: 700 }}>Camille R.</span>
        </div>
        <div style={{ color: t.soft, fontSize: 14, marginTop: 6 }}>Pose gel · 1h30 · 55 €</div>
        <div style={{ display: "flex", gap: 8, marginTop: 16, flexWrap: "wrap" }}>
          {["Il est arrivé", "Encaisser 55 €", "Absent"].map((l, i) => (
            <span key={l} style={{
              padding: "9px 13px", borderRadius: t.r, fontSize: 13, fontWeight: 700,
              background: i === 1 ? t.acc : "transparent",
              color: i === 1 ? t.bg : i === 2 ? t.acc2 : t.txt,
              border: `1px solid ${i === 1 ? t.acc : t.rule}`,
            }}>{l}</span>
          ))}
        </div>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
        {[["Aujourd'hui", "220 €"], ["Remplissage", "78 %"]].map(([k, v]) => (
          <div key={k} style={{ flex: 1, background: t.surf, border: `1px solid ${t.rule}`, borderRadius: t.r, padding: 14 }}>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".13em", color: t.soft, textTransform: "uppercase" }}>{k}</div>
            <div style={{ fontFamily: t.titre, fontSize: grand ? 30 : 24, marginTop: 6 }}>{v}</div>
          </div>
        ))}
      </div>
      <div style={{ height: 6, background: t.rule, borderRadius: 99, marginTop: 14, overflow: "hidden" }}>
        <div style={{ width: "78%", height: "100%", background: t.acc2 }} />
      </div>
    </div>
  );
}

export default function Styles() {
  const [zoom, setZoom] = useState(null);
  const cles = Object.keys(T);
  return (
    <div style={{ minHeight: "100vh", background: "#0E0E10", color: "#EDEAE6", fontFamily: "'Manrope', sans-serif" }}>
      <link href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:wght@400;600&family=Archivo:wght@400;700;900&family=Manrope:wght@400;600;700&family=Fraunces:wght@400;600&display=swap" rel="stylesheet" />
      <div style={{ maxWidth: 1240, margin: "0 auto", padding: "40px 20px 80px" }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".16em", color: "#D9B98C", textTransform: "uppercase" }}>
          Choix de la direction artistique
        </div>
        <h1 style={{ fontFamily: "'Bodoni Moda', serif", fontSize: 40, margin: "14px 0 8px", fontWeight: 400 }}>
          Trois pistes, un même écran.
        </h1>
        <p style={{ color: "#9C978F", maxWidth: 620, lineHeight: 1.6 }}>
          Le même écran « prochain client » décliné trois fois. Clique sur une maquette pour
          l'agrandir, puis dites-moi simplement <strong style={{ color: "#EDEAE6" }}>A, B ou C</strong> —
          ou un mélange (« le A mais avec les couleurs du C »).
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 20, marginTop: 34 }}>
          {cles.map((k) => {
            const t = T[k];
            return (
              <div key={k} data-testid={`direction-${k}`} style={{ border: "1px solid #26262C", borderRadius: 12, overflow: "hidden", background: "#141418" }}>
                <div style={{ padding: "18px 18px 14px" }}>
                  <div style={{ fontSize: 17, fontWeight: 700 }}>{t.nom}</div>
                  <div style={{ color: "#9C978F", fontSize: 13, marginTop: 4 }}>{t.tag}</div>
                  <div style={{ display: "flex", gap: 6, marginTop: 12 }}>
                    {[t.bg, t.surf, t.txt, t.acc, t.acc2].map((c) => (
                      <span key={c} title={c} style={{ width: 26, height: 26, borderRadius: 6, background: c, border: "1px solid #33333B" }} />
                    ))}
                  </div>
                </div>
                <button onClick={() => setZoom(k)} style={{ display: "block", width: "100%", border: 0, padding: 0, cursor: "zoom-in", background: "none" }}>
                  <Maquette t={t} />
                </button>
                <div style={{ padding: "14px 18px 18px", fontSize: 13, lineHeight: 1.6 }}>
                  <div style={{ color: "#8FBF9E" }}>+ {t.pour}</div>
                  <div style={{ color: "#D69A8C", marginTop: 4 }}>− {t.contre}</div>
                  <div style={{ color: "#7C776F", marginTop: 10, fontSize: 12 }}>
                    Titres : {t.titre.split(",")[0].replace(/'/g, "")} · Interface : {t.ui.split(",")[0].replace(/'/g, "")}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {zoom && (
        <div onClick={() => setZoom(null)} style={{ position: "fixed", inset: 0, background: "rgba(8,8,10,.88)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, cursor: "zoom-out", zIndex: 50 }}>
          <div style={{ width: "min(680px, 100%)", borderRadius: 14, overflow: "hidden", border: "1px solid #2A2A33" }}>
            <Maquette t={T[zoom]} grand />
          </div>
        </div>
      )}
    </div>
  );
}
